import React, { useEffect, useState } from 'react';
import { Box, keyframes } from '@mui/material';

interface Snowflake {
  id: number;
  left: number;
  animationDuration: number;
  animationDelay: number;
  size: number;
  opacity: number;
  drift: number;
}

const SnowEffect: React.FC = () => {
  const [snowflakes, setSnowflakes] = useState<Snowflake[]>([]);

  useEffect(() => {
    // Create 100 snowflakes with random properties - more visible on light backgrounds
    const flakes: Snowflake[] = Array.from({ length: 100 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      animationDuration: 8 + Math.random() * 15, // 8-23 seconds (faster)
      animationDelay: Math.random() * 5, // 0-5 seconds
      size: 4 + Math.random() * 8, // 4-12px (larger)
      opacity: 0.8 + Math.random() * 0.2, // 0.8-1.0 (more opaque)
      drift: (Math.random() * 30 - 15), // -15px to 15px horizontal drift
    }));
    setSnowflakes(flakes);
  }, []);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 1.5,
        overflow: 'hidden',
      }}
    >
      {snowflakes.map((flake) => {
        // Create unique keyframe for each flake with its drift value
        const snowfallAnimation = keyframes`
          0% {
            transform: translateY(0) translateX(0);
            opacity: ${flake.opacity};
          }
          50% {
            opacity: ${flake.opacity * 0.8};
          }
          100% {
            transform: translateY(100vh) translateX(${flake.drift}px);
            opacity: 0;
          }
        `;

        return (
          <Box
            key={flake.id}
            sx={{
              position: 'absolute',
              top: '-10px',
              left: `${flake.left}%`,
              width: `${flake.size}px`,
              height: `${flake.size}px`,
              backgroundColor: 'white',
              borderRadius: '50%',
              opacity: flake.opacity,
              boxShadow: `0 0 ${flake.size * 4}px rgba(255, 255, 255, 1), 0 0 ${flake.size * 2}px rgba(255, 255, 255, 0.9), 0 2px 4px rgba(0, 0, 0, 0.1)`,
              filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15))',
              animation: `${snowfallAnimation} ${flake.animationDuration}s linear infinite`,
              animationDelay: `${flake.animationDelay}s`,
            }}
          />
        );
      })}
    </Box>
  );
};

export default SnowEffect;

